import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import ToastMsg from '../components/common/ToastMsg';

const useApiWrapper = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const apiWrapper = async (apiCall, setLoading) => {
    try {
      if (setLoading) setLoading(true);

      const response = await apiCall();

      // Handle auth rejection from backend payload
      if (response?.detail === 'You are not authorized to perform this action') {
        logout();
        navigate('/');
        return { status: 'fail', message: response.detail };
      }

      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401 && !sessionStorage.getItem('token')) {
          return { status: 'fail', message: '' };
        }

        const msg =
          error.response.data?.message ||
          error.response.data?.detail ||
          'An error occurred.';

        return { status: 'fail', message: msg };
      } else if (error.request) {
        return { status: 'fail', message: 'Network error' };
      } else {
        ToastMsg('error', error.message || 'Unexpected error occurred.');
        return { status: 'fail', message: error.message };
      }
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  return { apiWrapper };
};

export default useApiWrapper;
